// extracted by mini-css-extract-plugin
export var content = "_m6-1";
export var fullScreen = "_m6-0";